<template>
  <div style="overflow: hidden; position: relative">
    <LocationMap
      v-if="!locationPinned"
      mapStyle="height: 400px"
      :coordinates="coordinates"
      @selectLocation="selectLocation"
    />
    <div v-else>
      <LocationMap
        mapStyle="height: 200px"
        :isPreview="true"
        :coordinates="coordinates"
      />
      <vs-button
        @click="toggleLocationPinned()"
        color="primary"
        class="button"
        block
        icon-pack="feather"
        icon="icon-check"
        >اصلاح موقعیت نقشه</vs-button
      >
      <vs-col vs-justify="center" vs-align="center" vs-w="12" class="mt-8">
        جزئیات آدرس:
        <vs-input v-model="location" class="w-100 mt-1" />
      </vs-col>
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" style="width: auto">
          <vs-button
            @click="submitAddress()"
            color="primary"
            block
            icon-pack="feather"
            icon="icon-check"
            >تائید و {{ isUpdate ? "ویرایش" : "انتخاب" }} آدرس</vs-button
          >
        </vs-col>
        <vs-col v-if="isUpdate" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            @click="removeAddress()"
            color="danger"
            block
            icon-pack="feather"
            icon="icon-x"
            >حذف آدرس</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LocationMap from "../../components/map/LocationMap.vue";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "ProviderAddress",
  components: {
    LocationMap,
  },
  data() {
    return {
      locationPinned: this.isUpdate,
      coordinates: this.address.coordinates,
      location: this.address.location,
    };
  },
  methods: {
    toggleLocationPinned() {
      this.locationPinned = !this.locationPinned;
    },
    selectLocation(coordinates) {
      this.locationPinned = true;
      this.coordinates = coordinates;
    },
    submitAddress() {
      if (!this.location) {
        this.$vs.notify({
          text: "وارد کردن جزئیات آدرس اجباریست.",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.$vs.loading();
      providerApiService
        .submitOrUpdateAddress(
          this.currentProvider.id,
          this.coordinates[0],
          this.coordinates[1],
          this.location,
          this.address.id,
          this.isUpdate
        )
        .then((result) => {
          this.$emit("locationAdded", result.resource);
        })
        .finally(() => this.$vs.loading.close());
    },
    removeAddress() {
      this.$vs.loading();
      providerApiService
        .deleteAddress(this.currentProvider.id, this.address.id)
        .then(() => this.$emit("locationRemoved"))
        .finally(() => this.$vs.loading.close());
    },
  },
  props: {
    isUpdate: {
      required: true,
      type: Boolean,
    },
    address: {
      required: true,
      type: Object,
    },
  },
  mounted() {},
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
};
</script>

<style scoped lang="scss">
.button {
  position: absolute;
  bottom: 175px;
  right: 5px;
  z-index: 1000;
}
</style>
